import React from 'react';
import PublicPageLayout from '../../components/layout/PublicPageLayout';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiLock, FiEyeOff, FiServer, FiCheck } = FiIcons;

const AnonymVarslingPage = () => {
  return (
    <PublicPageLayout 
      title="Anonym Varsling" 
      subtitle="Hvorfor anonymitet er avgjørende for et effektivt varslingssystem."
      activePage="/anonym-varsling"
    >
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
        
        {/* Introduction */}
        <section className="text-lg text-slate-600 leading-relaxed font-medium">
          <p>
            Anonym varsling senker terskelen for å si ifra om alvorlige forhold. For mange er frykten for konsekvenser eller sosial stigmatisering den største barrieren for å varsle. Ved å tilby en garantert anonym kanal, viser virksomheten at de prioriterer åpenhet og trygghet høyere enn behovet for å vite "hvem".
          </p>
        </section>

        {/* Technical vs Organizational Anonymity */}
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600 mb-6">
              <SafeIcon icon={FiServer} className="text-2xl" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">Teknisk Anonymitet</h3>
            <p className="text-slate-600">
              Vår plattform logger ikke IP-adresser eller metadata som kan spore varsleren. All kommunikasjon er kryptert ende-til-ende. Selv ikke systemadministratorer har mulighet til å avsløre avsenderen.
            </p>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center text-purple-600 mb-6">
              <SafeIcon icon={FiEyeOff} className="text-2xl" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">Organisatorisk Trygghet</h3>
            <p className="text-slate-600">
              Vi legger til rette for toveis kommunikasjon med anonyme varslere. Dette betyr at saksbehandler kan stille oppfølgingsspørsmål og gi tilbakemelding uten at varsleren må oppgi navn eller e-post.
            </p>
          </div>
        </div>

        {/* Why it matters - Mode 2: Reflective */}
        <section className="space-y-6">
          <h2 className="text-3xl font-bold text-slate-900">Rettsikkerhet for alle parter</h2>
          <p className="text-slate-600 leading-relaxed">
            Mange arbeidsgivere er skeptiske til anonyme varsler fordi det kan være vanskeligere å undersøke saken (kontradiksjon) når man ikke vet hvem kilden er. Vår løsning balanserer dette ved å tillate dialog.
          </p>
          <p className="text-slate-600 leading-relaxed">
            Anonymitet er ikke et hinder for en god prosess, men ofte en forutsetning for at saken i det hele tatt kommer frem i lyset. Det er innholdet i varselet som skal undersøkes, ikke avsenderen.
          </p>
        </section>

        {/* Checklist */}
        <section className="bg-gray-50 rounded-2xl p-8">
          <h3 className="text-xl font-bold text-slate-900 mb-6">Slik sikrer vi anonymitet</h3>
          <ul className="space-y-4">
            {[
              "Ingen lagring av IP-adresser",
              "Ingen sporing av enhet eller nettleser",
              "Mulighet for å kommunisere via sikker, kryptert chat",
              "Varsler velger selv om de vil oppgi navn senere i prosessen",
              "Ekstern serverplassering uavhengig av bedriftens IT-system"
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-3">
                <SafeIcon icon={FiCheck} className="text-green-500 flex-shrink-0" />
                <span className="text-slate-700">{item}</span>
              </li>
            ))}
          </ul>
        </section>

      </article>
    </PublicPageLayout>
  );
};

export default AnonymVarslingPage;